import { apiUrls } from '../../constants/apiUrls';
import { handlePromise } from '../apiControllers/helpers';
import ENV from '../../Environments';
import { getLoggedInUser } from '../../common/utility';

export const sendUserOTP = (payload) => {
  const apiPayload = {
    method: 'POST',
    url: ENV.getTeamIAMUrl() + apiUrls.sendUserOTP,
    data: payload
  };

  return handlePromise(apiPayload);
};

export const sendUserOTPV4 = (payload) => {
  const apiPayload = {
    method: 'POST',
    url: ENV.getTeamIAMUrl() + apiUrls.sendUserOTPV4,
    data: payload
  };

  return handlePromise(apiPayload);
};

export const userLogin = (headers, payload) => {
  const apiPayload = {
    method: 'POST',
    url: ENV.getTeamIAMUrl() + "/v5/login?",
    data: payload,
    headers: headers
  };

  return handlePromise(apiPayload);
};

export const SignUp = (payload, headers) => {
  const apiPayload = {
    method: 'POST',
    url: ENV.getTeamIAMUrl() + apiUrls.signUp,
    data: payload,
    headers: headers
  };

  return handlePromise(apiPayload);
};

export const fetchPublicRsaKeyAPI = () => {
  const apiPayload = {
    method: 'GET',
    url: ENV.getTeamCommonUrl() + apiUrls.RsaKey
  };

  return handlePromise(apiPayload);
};

export const logoutApi = () => {
  try {
    const { refreshToken } = getLoggedInUser();
    let headers = {
      "refresh_token": refreshToken
    };
    const apiPayload = {
      method: 'POST',
      url: ENV.getTeamIAMUrl() + apiUrls.logOut,
      headers: headers,
      isLogout: true
    };
    return handlePromise(apiPayload);
  }
  catch (e) {
    console.log(e);
  }
}

export const validateUserOTP = (payload) => {
  const apiPayload = {
    method: 'POST',
    url: ENV.getTeamIAMUrl() + apiUrls.validateOTP,
    data: payload
  };
  return handlePromise(apiPayload);
};
